import { useMemo } from "react";
import S from "./useStackOnMobile.module.scss";

export const useStackOnMobile = (itemStackOnMobile: string) => {
    const stackOnMobileClassName = useMemo(() => {
        switch (itemStackOnMobile) {
            case "ITEMS_STACK_ON_MOBILE":
                return S.stackOnMobile;
        }
    }, [itemStackOnMobile]);

    return { stackOnMobileClassName };
};
